import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-patient-portal-button',
  imports: [CommonModule],
  template: `
    <button 
      type="button"
      class="portal-login-btn"
      [class]="customClass"
      (click)="openPatientPortal()">
      {{ buttonText }}
    </button>
  `,
  styles: [`
    .portal-login-btn {
      width: fit-content;
      height: 35px;
      background-color: #2367B9;
      color: white;
      border: none;
      border-radius: 32px;
      padding: 16px 30px;
      gap: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .portal-login-btn:hover {
      background-color: #1e5ba3;
      transform: translateY(-1px);
    }

    /* Responsive */
    @media (max-width: 768px) {
      .portal-login-btn {
        width: fit-content;
        height: 38px;
        padding: 12px 20px;
        font-size: 13px;
      }
    }
  `]
})
export class PatientPortalButton {
  @Input() portalUrl: string = 'https://patient-portal.animosanopsychiatry.com';
  @Input() buttonText: string = 'Patient Portal Log In';
  @Input() customClass?: string;

  openPatientPortal() {
   
    window.open(this.portalUrl, '_blank');
  }
}